function ChecklistCtrl($scope, $state, $auth, toaster, $stateParams, $rootScope, ChecklistService, $window, $timeout, CommonService, dragulaService) {
  'ngInject';

  const vm = this;
  vm.loading = false;
  vm.user = $auth.user;
  vm.addChecklistFlag = false;
  vm.showTasks = false;
  vm.addChecklistForm = {};
  vm.addTaskForm = {};
  vm.taskLoading = false;
  vm.tasks = {};
  vm.taskArray = [];
  vm.editTaskFlag = false;
  vm.taskId = !$stateParams.taskId ? '' : $stateParams.taskId;
  vm.checklistId = !$stateParams.id ? '' : $stateParams.id;
  vm.currentPage = 1;
  vm.lazyLoading = false;
  vm.publishView = {};
  vm.organizations = [];
  vm.selectedOrganizations = [];
  vm.attachTaskId = '';
  vm.publishChecklistId = '';

  angular.element($window).bind('scroll', function(e) {
    if(($state.current.name == 'user.admin.checklists.default')){
      if ($(window).scrollTop() + $(window).height() == $(document).height()) {
        vm.paginate();
      }
    }
  });

  vm.init = function () {
    $rootScope.organizationNameView = false;
    if (vm.taskId) {
      ChecklistService.getTaskDetails(vm.taskId, function (response) {
        if (response.status >= 200 && response.status < 300) {
          for (var key in response.data) {
            if (response.data.hasOwnProperty(key) && (response.data[key] == null || response.data[key] == undefined)) {
              response.data[key] = '';
            }
        }
        vm.addTaskForm = response.data;
        }
      });
    } else {
      vm.loading = true;
      ChecklistService.getBaseTasks(vm.currentPage, function (response) {
        vm.loading = false;
        vm.taskLoading = true;
        if (response.status >= 200 && response.status < 300) {
          vm.baseTasks = response.data.base_tasks;
          vm.childTasks = response.data.child_tasks;
          vm.tasks = {};
            vm.childTasks.forEach(task => {
              if(!vm.tasks[task.parent_id]){
                vm.tasks[task.parent_id] = [];
              }
              vm.tasks[task.parent_id].push(task) ;
            });
            vm.taskLoading = false;
        }
      });
      ChecklistService.getOrganizations(function (response) {
        if (response.status >= 200 && response.status < 300) {
          vm.organizations = response.data.organizations;
        }
      });

    }
  };

  vm.loadOrganizations = function (query) {
    var organizationList = [];
    for (var i = 0, len = vm.organizations.length; i < len; i++) {
      var organizationName = vm.organizations[i].name.toLowerCase();
      if (organizationName.includes(query.toLowerCase())) {
        organizationList.push(vm.organizations[i]);
      }
    }
    return organizationList;
  };

  $(document).on("trix-attachment-add", function(event) {
    var addedFile = event.originalEvent.attachment.file;
    var attachment = event.originalEvent.attachment;
    if (addedFile) {
      CommonService.addDescriptionImage(addedFile, function (response) {
        let attributes = CommonService.getAttachmentAttributes(addedFile, response.data);
        
        attachment.setAttributes(attributes);
      });
    }
  });

  vm.paginate = function () {
    if(!vm.lazyLoading ){
      vm.lazyLoading = true;
      vm.currentPage = vm.currentPage + 1;
      ChecklistService.getBaseTasks(vm.currentPage, function (response) {
      vm.loading = false;
      vm.lazyLoading = false;
      if (response.status >= 200 && response.status < 300) {
        if(vm.currentPage == response.data.pagination.current_page){
          if(response.data.base_tasks.length <= 0){
            vm.currentPage = vm.currentPage - 1;
          } else {
            vm.baseTasks = vm.baseTasks.concat(response.data.base_tasks);
          }
        } 
      }
    });
    }
  };

  vm.uploadFiles = function(files, errFiles) {
    vm.attachments = files;
  };

  vm.addAttachment = function(){
    if (vm.attachmentForm && vm.attachmentForm.url){
      ChecklistService.addAttachment(vm.attachTaskId, vm.attachmentForm.url, function (response) {
        if(response.status >= 200 && response.status < 300){
          toaster.pop('info', 'Attachments uploaded successfully.');
        } else {
          toaster.pop('error', CommonService.throwError(response));
        }
        $('#addAttachmentModal').modal('hide');
        vm.init();
      });
    } else {
      toaster.pop('error', 'Select File.');
    }
  };
  
  vm.addAttachmentView = function (taskId) {
    vm.attachTaskId = taskId;
    vm.attachments = [];
    $('#addAttachmentModal').modal('show');
  };

  vm.getAttachmentClass = function (url) {
    return CommonService.attachmentClass(url);
  };

  vm.editChecklist = function(id, $event){
    $event.preventDefault();
    $event.stopPropagation();
    $timeout(function(){
      $('#editable-'+ id).trigger('click');
    });
  };

  vm.getChildTasks = function (parentId) {
    vm.taskLoading = true;
    vm.tasks[parentId] = [];
    ChecklistService.getChildTasks(parentId, function (response) {
      vm.taskLoading = false;
      if (response.status >= 200 && response.status < 300) {
        vm.taskArray = response.data.base_tasks;
        vm.tasks[parentId] = vm.taskArray;
      }
    });
  };

  vm.addNewChecklist = function () {
    vm.addChecklistFlag = true;
  };

  vm.addTask = function (parentId) {
    $state.go('user.admin.checklists.taskNew', {
      id: parentId
    }, {
      inherit: false
    });
  };

  vm.saveChecklist = function () {
    vm.submitted = true;
    ChecklistService.newChecklist(vm.addChecklistForm, function (response) {
      if (response.status >= 200 && response.status < 300) {
        vm.addChecklistFlag = false;
        vm.init();
        vm.addChecklistForm = {};
        toaster.pop('info', 'Checklist added successfully.');
      }
    });
  };

  vm.inlineSave = function (checklist) {
    let updateData = { title: checklist.title };
    ChecklistService.updateChecklistAndTask(checklist.id, updateData, function (response) {
      if (response.status >= 200 && response.status < 300) {
        toaster.pop('info', 'Checklist updated successfully.');
      }
    });
  };

  vm.inlineEditValidate = function (data) {
    if(!data){
      return "Checklist title cannot be empty";
    }
  };

  vm.saveTask = function () {
    vm.submitted = true;
    vm.taskLoading = true;
    if (vm.taskId) {
      ChecklistService.updateChecklistAndTask(vm.taskId, ChecklistService.formParams(vm.addTaskForm, vm.checklistId), function (response) {
        if (response.status >= 200 && response.status < 300) {
          vm.taskLoading = false;
          toaster.pop('info', 'Task updated successfully.');
          $state.go('user.admin.checklists.default', {
            inherit: false
          });
        } else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });
    } else {
      ChecklistService.newTask(ChecklistService.formParams(vm.addTaskForm, vm.checklistId), function (response) {
        if (response.status >= 200 && response.status < 300) {
          vm.taskLoading = false;
          toaster.pop('info', 'Task saved successfully.');
          $state.go('user.admin.checklists.default', {
            inherit: false
          });
        } else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });
    }
  };

  vm.cancelBtn = function () {
    vm.addChecklistFlag = false;
    vm.addTaskForm = {};
    vm.editTaskFlag = false;
    $state.go('user.admin.checklists.default', {
      inherit: false
    });
  };

  vm.editTask = function (parentId, taskId) {
    $state.go('user.admin.checklists.taskNew', {
      id: parentId,
      taskId: taskId
    }, {
      inherit: false
    });
  };

  vm.deleteChecklistAndTask = function (taskId, parentId) {
    swal({
        title: 'Are you sure?',
        text: 'Are you sure to delete this task.',
        icon: 'warning',
        dangerMode: true,
        buttons: [true, true],
      })
      .then(willDelete => {
        if (willDelete) {
          ChecklistService.deleteChecklistAndTask(taskId, function (response) {
            if (response.status >= 200 && response.status < 300) {
              toaster.pop('info', 'Task deleted successfully.');
              if (parentId) {
                vm.getChildTasks(parentId);
              }
              vm.init();
            } else {
              toaster.pop('error', CommonService.throwError(response));
            }
          });
        }
      });
  };
  vm.removeImage = function (taskId, checklistId, file) {
    swal({
        title: 'Are you sure?',
        text: 'Attachment will be removed.',
        icon: 'warning',
        dangerMode: true,
        buttons: [true, true]
      })
      .then(willDelete => {
        if (willDelete) {
          ChecklistService.removeImage(taskId, file, function (response) {
            if (response.status >= 200 && response.status < 300) {
              toaster.pop('info', 'Attachment removed.');
              vm.getChildTasks(checklistId);
            } else {
              toaster.pop('error', CommonService.throwError(response));
            }
          });
        }
      });
  };

  vm.publishView = function (checklistId) {
    vm.publishChecklistId = checklistId;
    vm.selectedOrganizations =[];
    $('#publishModal').modal('show');
  };

  vm.validateTags = function(tag){
      return tag.id !== undefined;
  };

  vm.publishChecklist = function () {
    vm.selectedOrganizations = vm.selectedOrganizations.filter(x => x.id !== undefined);
    let organizations = vm.selectedOrganizations.map(x => x.id);
    if (!organizations || organizations.length <= 0) {
      vm.selectedOrganizations = [];
      toaster.pop('error', 'Organizations have not been selected.');
    } else {
      ChecklistService.publishChecklist(vm.publishChecklistId, organizations, function (response) {
        if (response.status >= 200 && response.status < 300) {
          toaster.pop('info', 'Checklist successfully published.');
          vm.selectedOrganizations = [];
          $('#publishModal').modal('hide');
        } else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });
    }
  };

  //for task drag and drop by handle(:::) only
  dragulaService.options($scope, 'container', {
    revertOnSpill: true,
    moves: function (el, container, handle) {
      return handle.className.includes('handle');
    },
    accepts: function (el, target, source, sibling) {
      return target.id == el.id.split('.')[0];
    }
  });

   //task drop event
  $scope.$on('container.drop', function (e, el, target, source){
   var domIndex = Array.prototype.indexOf.call(angular.element(target).children(), el[0]);
   if(domIndex != -1){
    var parentId = target[0].id;
    var elementId = el[0].id.split('.');
    if(elementId[0] == parentId){
      var replacedTask = vm.tasks[parentId][domIndex];
      ChecklistService.rearrangeTask(elementId[1], replacedTask.position, function (response) {
        if (response.status >= 200 && response.status <300) {
          toaster.pop('info', 'Tasks successfully rearranged.');
        } else {
          toaster.pop('error', CommonService.throwError(response));
          vm.getChildTasks(parentId);
        }
      });
    } else {
      vm.getChildTasks(parentId);
      vm.getChildTasks(elementId[0]);
    }
   }
  });
}
export default {
  name: 'ChecklistCtrl',
  fn: ChecklistCtrl
};
